import React from "react";
import {
  Backdrop,
  Slide,
  Paper,
  makeStyles,
  Container,
  Box,
  Typography,
  useTheme,
  ClickAwayListener,
  Grid,
  Chip,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    "& .MuiChip-root": {
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
  spanValue: {
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(2),
  },
  container: {
    zIndex: 1,
    position: "absolute",
    margin: theme.spacing(1),
    width: "40%",
    minWidth: 600,
    height: "100vh",
    right: 0,
    padding: theme.spacing(2),
    background: theme.palette.background.default,
    "& .MuiPaper-root": {
      padding: theme.spacing(2),
      boxShadow:
        "0px 6px 116px rgba(164, 166, 179, 0.21), 0px 1.80882px 34.9706px rgba(164, 166, 179, 0.136834), 0px 0.751293px 14.525px rgba(164, 166, 179, 0.105), 0px 0.271728px 5.25341px rgba(164, 166, 179, 0.0731663)",
      borderRadius: 16,
    },
    "& .MuiTab-root": {
      minWidth: 120,
    },
    "& .MuiTabs-indicator": {
      height: 4,
      borderRadius: 4,
    },
    zIndex: theme.zIndex.drawer + 10,
  },
  link: {
    textDecoration: "none",
    color: theme.palette.primary.main,
  },
}));

const SignalManagerCompanyPotentialCandidates = ({
  companyDetails,
  onClose,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Backdrop
      className={classes.backdrop}
      open={parseInt(companyDetails.company.id) > 0}
    >
      <ClickAwayListener onClickAway={onClose}>
        <Slide
          direction="left"
          in={parseInt(companyDetails.company.id) > 0}
          mountOnEnter
          unmountOnExit
        >
          <Container className={classes.container}>
            <Paper>
              <Box my={2}>
                <Typography variant="h5" color="textPrimary">
                  {`Distribution #${companyDetails.company.id}`}
                </Typography>
              </Box>
              <Box
                display={"flex"}
                justifyContent="space-between"
                alignItems={"center"}
                my={2}
              >
                <Typography variant="body1" color="textPrimary">
                  Company:{" "}
                  {
                    <span className={classes.spanValue}>
                      {companyDetails.company.name}
                    </span>
                  }
                </Typography>
                <Typography variant="body1" color="textPrimary">
                  Distributed At:{" "}
                  {
                    <span className={classes.spanValue}>
                      {companyDetails.details &&
                        companyDetails.details.distributed_at}
                    </span>
                  }
                </Typography>
              </Box>
              <Box>
                Distributed By:{" "}
                {
                  <span className={classes.spanValue}>
                    {companyDetails.details && companyDetails.details.author}
                  </span>
                }
              </Box>
            </Paper>
            <Paper style={{ marginTop: theme.spacing(2) }}>
              <Typography variant="subtitle1" color="primary">
                Potential Candidates
              </Typography>
              <Box my={2}>
                <Grid container spacing={1}>
                  <Grid item xs={1}>
                    <Typography variant="subtitle1" color="textSecondary">
                      ID
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography variant="subtitle1" color="textSecondary">
                      Fullname
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle1" color="textSecondary">
                      Categories
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography variant="subtitle1" color="textSecondary">
                      Mobile
                    </Typography>
                  </Grid>
                </Grid>
                {companyDetails &&
                  companyDetails.details &&
                  companyDetails.details.candidates.map((cand) => (
                    <CandidatePotentialItem candidate={cand} key={cand.id} />
                  ))}
              </Box>
            </Paper>
          </Container>
        </Slide>
      </ClickAwayListener>
    </Backdrop>
  );
};
export default SignalManagerCompanyPotentialCandidates;

const CandidatePotentialItem = ({ candidate }) => {
  const classes = useStyles();
  const { id, name, professions, acf } = candidate;
  return (
    <Grid container spacing={1}>
      <Grid item xs={1}>
        <Typography variant="body1" color="textPrimary">
          {id}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="body1" color="textPrimary">
          {name}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        {professions.map((prof) => (
          <Chip label={prof.name} key={prof.id} size="small" />
        ))}
      </Grid>
      <Grid item xs={2}>
        <Typography variant="body1" color="textPrimary">
          <a className={classes.link} href={`tel:${acf.mobile}`}>
            {acf.mobile}
          </a>
        </Typography>
      </Grid>
    </Grid>
  );
};
